import type { ReactNode } from 'react'
import { FormGroup, FormRow, Help } from '@/components/Form'
import {
  CurrentMemberInfo,
  type CurrentMemberInfoProps,
} from '@/features/jobs/TransferJobDialog/CurrentMemberInfo'

export interface ClientInputEditorProps {
  currentClient?: Omit<CurrentMemberInfoProps, 'subtitle'>
  clientSelect: ReactNode
  clientError?: string
}

export function ClientInputEditor({
  currentClient,
  clientSelect,
  clientError,
}: ClientInputEditorProps) {
  return (
    <>
      {currentClient && (
        <FormRow>
          <FormGroup>
            <CurrentMemberInfo {...currentClient} subtitle="Current Client" />
          </FormGroup>
        </FormRow>
      )}
      <FormRow>
        <FormGroup label="New Client">
          {clientSelect}
          <Help
            error={clientError}
            help={
              <>
                Make sure that the Client and/or Team you are transferring to
                has a valid billing method!
              </>
            }
          />
        </FormGroup>
      </FormRow>
    </>
  )
}
